module.exports = __webpack_public_path__ + "static/media/map.f8c89a31.svg";